import { request } from "./request";

export const apiProfile = (data = {}, config = {}) => {
  return request("get", "/profile-cms", data, config);
};

export const apiChangePassword = (data = {}, config = {}) => {
  return request("patch", "/profile-cms/change-password", data, config);
};
